import React from "react";

import BookingForm from "./BookingForm";
import Logo from "../Ui/Logo";
import styles from "./styles";

export default function Booking() {
	const classes = styles();

	return (
		<div className={classes.outer}>
			<Logo />
			<div className={classes.bookingwrapper}>
				<div className={classes.bookingheader}>
					<span className="breve h2 newBrave">Inquire Room Now</span>
				</div>
				<div className={classes.formContent}>
                <BookingForm />
				</div>
			</div>
		</div>
	);
}
